module.exports = __webpack_public_path__ + "static/img/jiaotongyunshu-2.f38b2d10.svg";